const getItem = (estimateBuilder, itemId) => {
  const {
    entities: {
      items,
    },
  } = estimateBuilder;
  return items.byId[itemId];
};

export default getItem;
